import { Entity } from "app/core/commons/entity";
import { DynField } from "../dyn-field";
import { DynFieldData } from "../../data";


export class DynFillableTextField extends DynField {

    constructor(){
        super(null,"fillableText")
    }


}



// WEBPACK FOOTER //
// ./src/app/forms/domain/meta/fields/dyn-fillable-text-field.ts